const BaseURL = () => {
    return 'https://ussd-login.setareaval.ir/';
};

export default BaseURL;
